export default __webpack_public_path__ + "static/media/case-study-h5.17ea2133.png";